import { useState, useEffect } from 'react'

const WATCH_POSITION_OPTIONS = {
  enableHighAccuracy: false,
  timeout: 5000,
  maximumAge: 5000, // cache location for 5 seconds
}

export const isLocation = (location) => location.latitude && location.longitude

const useGeolocation = () => {
  const [state, setState] = useState({
    latitude: null,
    longitude: null,
    timestamp: Date.now(),
  })
  let mounted = true
  let watchId

  const onEvent = (event) => {
    if (mounted) {
      setState({
        latitude: event.coords.latitude,
        longitude: event.coords.longitude,
        timestamp: event.timestamp,
      })
    }
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(onEvent)
    watchId = navigator.geolocation.watchPosition(
      onEvent,
      null, // for now we do nothing in case an error occurs
      WATCH_POSITION_OPTIONS
    )

    return () => {
      mounted = false
      navigator.geolocation.clearWatch(watchId)
    }
  }, [0])

  return state
}

export default useGeolocation
